import Immutable from 'immutable';
import config from 'react-global-configuration';
export function getLanguageByPath(path) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.get('DEFAULT_LANGUAGE', '');
  return /^\/[a-z]{2}(\/.*)?$/g.test(path) ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1') : fallback;
}
export function getDocumentTitle(title) {
  var SITE_NAME = config.get('SITE_NAME');
  if (!title) {
    return SITE_NAME;
  }
  return "".concat(title, " | ").concat(SITE_NAME);
}
export function enableDrupalLogging(error) {
  window.addEventListener('error', function (error) {
    var API_URL = config.get('API_URL');
    if (error) {
      var data = {
        message: error.error.stack.toString(),
        path: window.location.href,
        severity: 'error'
      };
      fetch("".concat(API_URL, "/dblog/logger"), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    }
  });
}
export function getOneTimeLoginParams(path) {
  return {
    uid: parseInt(path.split('/').slice(-3)[0]),
    timestamp: parseInt(path.split('/').slice(-2)[0]),
    hash: path.split('/').slice(-1)[0]
  };
}
var wizardTypes = ['wizard_page', 'webform_wizard_page'];
export function checkIfWebformHasWizardWithButtons(object) {
  var checkIfWizardExist = function checkIfWizardExist(obj) {
    if (Immutable.Map.isMap(obj)) {
      if (wizardTypes.includes(obj.get('#type'))) {
        return true;
      }
      return obj.some(function (value) {
        return checkIfWizardExist(value);
      });
    }
    return false;
  };
  var checkForNextPrevButtons = function checkForNextPrevButtons(page) {
    var type = page.get('#type');
    return wizardTypes.includes(type) && (page.has('#next_button_label') || page.has('#prev_button_label'));
  };
  if (checkIfWizardExist(object) === false) {
    return false;
  }
  var traverse = function traverse(obj) {
    if (Immutable.Map.isMap(obj)) {
      var type = obj.get('#type');
      if (wizardTypes.includes(type) && !checkForNextPrevButtons(obj)) {
        return false;
      }
      return obj.every(function (value) {
        return traverse(value);
      });
    }
    return true;
  };
  return traverse(object);
}